export default __webpack_public_path__ + "static/media/Coursera Google Drawing.b9fb9164.png";